export default __webpack_public_path__ + "static/media/view4_month_province_place_.dfa6dcb4.csv";